// Angular
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
// Misc
import { get as _get } from 'lodash';

import { ClaimDetailServiceRequestModel } from '@amfam/claim/data-access';

// Constants
import { ClaimDetailConstant } from '../../models/claim-detail-constants';
// Models
import { ServiceRequestPartnerDataModel } from '../../models/claim-rental-data.model';
import { ClaimTowingRepairDataModel } from '../../models/claim-towing-repair-data.model';

@Component({
  selector: 'ds-claim-status-towing-repair-shops',
  templateUrl: './claim-status-towing-repair-shops.component.html',
  styleUrls: ['../../containers/auto-claim-status/auto-claim-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimStatusTowingRepairShopsComponent implements OnInit {
  @Input() claimTowingRepairShopData: ClaimTowingRepairDataModel;
  @Input() claimNumber: string;

  towAndRepairShopData = new Array<ServiceRequestPartnerDataModel>();

  private serviceRequestPartnerData: ServiceRequestPartnerDataModel = {
    serviceRequestPartnerName: '',
    businessAddress: {
      addressLine1: '',
      city: '',
      state: '',
      zipCode: ''
    },
    phoneNumber: '',
    serviceRequestPartnerType: ''
  };

  constructor() {}

  ngOnInit() {
    this.showServicePartnerData(this.claimTowingRepairShopData.serviceRequestData);
  }

  private showServicePartnerData(serviceRequestData: Array<ClaimDetailServiceRequestModel>) {
    for (let i = 0; i < serviceRequestData.length; i++) {
      this.serviceRequestPartnerData.serviceRequestPartnerName = _get(
        serviceRequestData[i],
        'serviceRequestPartner',
        ''
      );
      if (
        _get(serviceRequestData[i], 'typeOfServiceRequestCode', '').toString().toUpperCase() ===
        ClaimDetailConstant.DREAM_REPAIR_PROGRAM
      ) {
        this.serviceRequestPartnerData.serviceRequestPartnerType = ClaimDetailConstant.REPAIR_SHOP;
      } else {
        this.serviceRequestPartnerData.serviceRequestPartnerType = ClaimDetailConstant.TOWING_SHOP;
      }
      if (_get(serviceRequestData[i], 'specialist.addresses')) {
        if (serviceRequestData[i].specialist.addresses.length > 0) {
          this.serviceRequestPartnerData.businessAddress.addressLine1 =
            serviceRequestData[i].specialist.addresses[0].addr1;
          this.serviceRequestPartnerData.businessAddress.city =
            serviceRequestData[i].specialist.addresses[0].city;
          this.serviceRequestPartnerData.businessAddress.state =
            serviceRequestData[i].specialist.addresses[0].state;
          this.serviceRequestPartnerData.businessAddress.zipCode =
            serviceRequestData[i].specialist.addresses[0].zip5;
        }
      }
      if (_get(serviceRequestData[i], 'specialist.phones')) {
        if (serviceRequestData[i].specialist.phones.length > 0) {
          this.serviceRequestPartnerData.phoneNumber =
            serviceRequestData[i].specialist.phones[0].areaCode +
            serviceRequestData[i].specialist.phones[0].number;
        }
      }
      this.towAndRepairShopData.push(this.serviceRequestPartnerData);
    }
  }
}
